import { render, staticRenderFns } from "./MailTemplates.vue?vue&type=template&id=0a03871e&scoped=true"
import script from "./MailTemplates.vue?vue&type=script&lang=js"
export * from "./MailTemplates.vue?vue&type=script&lang=js"
import style0 from "./MailTemplates.vue?vue&type=style&index=0&id=0a03871e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a03871e",
  null
  
)

export default component.exports